import React from "react";

export default function UrgencyBanner() {
  return (
    <div
      data-testid="urgency-banner"
      className="bg-[#373A45] text-white text-sm py-2 overflow-hidden relative"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {Array.from({ length: 2 }).map((_, blockIdx) => (
          <div key={blockIdx} className="flex items-center shrink-0">
            {[
              "Înscrierile sunt deschise pentru următoarea grupă",
              "Locuri limitate per cohortă",
              "25 de ore de formare practică pentru profesori",
              "Eligibil prin Prima de carieră didactică",
              "Plată cu cardul – inclusiv card Prima",
            ].map((t, i) => (
              <span key={i} className="mx-6 inline-flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-[#965EA7]" />
                {t}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
